import { useState } from "react";

const useRezReactTable = () => {
  const [sorting, setSorting] = useState([]);
  const [columnVisibility, setColumnVisibility] = useState({});
  const [globalFilter, setGlobalFilter] = useState("");
  const [openFilter, setOpenFilter] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState("");
  const [paddingIndex, setPaddingIndex] = useState(1);
  const [grouping, setGrouping] = useState([]);
  const [paginationState, setPaginationState] = useState({
    pageIndex: 0,
    pageSize: 50,
  });

  const togglePadding = () => {
    setPaddingIndex((paddingIndex + 1) % paddingGaps.length);
  };

  const paddingGaps = [`${"4px 8px"}`, `${"8px 12px"}`, `${"12px 16px"}`];
  const currentPadding = paddingGaps[paddingIndex];

  const hookOptions = {
    openFilter: openFilter,
    setOpenFilter: setOpenFilter,
    isDropdownOpen: isDropdownOpen,
    setIsDropdownOpen: setIsDropdownOpen,
    paddingIndex: paddingIndex,
    currentPadding: currentPadding,
    setPaddingIndex: togglePadding,
    sorting: sorting,
    setSorting: setSorting,
    columnVisibility: columnVisibility,
    setColumnVisibility: setColumnVisibility,
    globalFilter: globalFilter,
    setGlobalFilter: setGlobalFilter,
    grouping: grouping,
    setGrouping: setGrouping,
    pagination: paginationState,
    setPagination: setPaginationState,
  };

  return hookOptions;
};

export default useRezReactTable;
